// extracted by mini-css-extract-plugin
export default {"dialogInner":"CanadianCheckInstructions_dialogInner__azFwF","intro":"CanadianCheckInstructions_intro__ba4W2","mailToAddress":"CanadianCheckInstructions_mailToAddress__q22+h"};